var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-app",
    [
      _c(
        "v-toolbar",
        {
          staticClass: "elevation-0 hidden-sm-and-down stepped",
          attrs: { app: "", fixed: "" }
        },
        [
          _c(
            "v-layout",
            [
              _c("img", {
                staticClass: "mt-1 mr-3",
                attrs: {
                  src: require("assets/images/img_logo_niubiz_on_white.svg"),
                  width: "80px",
                  height: "30px"
                }
              }),
              _c("span", { staticClass: "pl-3 span-style" }, [
                _vm._v("GESTOR DE "),
                _c("br"),
                _vm._v("  AFILIACIÓN")
              ]),
              _c("v-toolbar-title", { staticClass: "mt-2" }, [
                _vm._v("Nueva Afiliación")
              ]),
              _c("v-spacer"),
              _c("v-layout", { attrs: { "justify-end": "" } }, [
                _c(
                  "div",
                  { staticClass: "toolbar__userName text-xs-right" },
                  [
                    _vm.isSuperUser
                      ? [
                          _c("h3", { staticClass: "mt-2" }, [
                            _vm._v("Administrador")
                          ])
                        ]
                      : [
                          _c("h3", { staticClass: "mt-2" }, [
                            _vm._v(_vm._s(_vm.firstName))
                          ]),
                          _c("span", [_vm._v(_vm._s(_vm.lastName))])
                        ]
                  ],
                  2
                )
              ]),
              _c(
                "v-btn",
                { attrs: { icon: "", flat: "" } },
                [
                  _c(
                    "v-icon",
                    {
                      staticStyle: { color: "#b4b9bf" },
                      on: {
                        click: function($event) {
                          _vm.$refs.CloseSessionModal.showModal()
                        }
                      }
                    },
                    [_vm._v("icon-ic-logout-plomo")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("close-session-modal", { ref: "CloseSessionModal" }),
      _c(
        "v-content",
        [
          _c(
            "v-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "transition",
                { attrs: { name: "slide-x-transition" } },
                [_c("nuxt")],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a0fbc018", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a0fbc018","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/stepped.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-a0fbc018","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/layouts/stepped.vue
// module chunks = 21